<template>
  <v-container
    fluid>
    <v-row no-gutters>
      <v-col
        class="pa-1"
        cols="8">
        <v-text-field
          v-model="searchNotice"
          label="Search Notice"
          append-icon="search"
          clearable
          outlined
          color="teal"
        />
      </v-col>

      <v-col
        class="pa-1"
        cols="4">
        <v-select
          v-model="orderModel"
          :items="orderByArray"
          label="Order by"
          @change="orderNotices"
          item-text="title"
          item-value="value"
          color="teal"
          outlined/>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col
        cols="12"
        v-for="notice in resultQuery"
        :key="notice.id">
        <notice-card
          :notice-obj="notice"
        />
      </v-col>
      <v-col v-if="filteredNotices.length === 0">
        <v-alert
          :value="true"
          type="info"
          class="white--text"
          transition="scale-transition">
          There are no notices at the moment.
        </v-alert>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import NoticeCard from '../components/NoticeCard'

export default {
  components: {
    NoticeCard
  },

  data: () => ({
    notices: [],
    searchNotice: '',
    orderByArray: [
      { title: 'Latest', value: 'desc' },
      { title: 'Oldest', value: 'asc' }
    ],
    orderModel: 'desc'
  }),

  computed: {
    filteredNotices: function () {
      return this.notices.filter(notice => typeof notice.id !== 'undefined')
    },
    resultQuery () {
      if (this.searchNotice) {
        return this.filteredNotices.filter((item) => {
          return this.searchNotice.toLowerCase().split(' ').every(v => item.contents.toLowerCase().includes(v))
        })
      } else {
        return this.filteredNotices
      }
    }

  },
  created: function () {
    this.orderNotices()
  },
  methods: {
    orderNotices: function () {
      if (this.orderModel === 'desc') {
        return this.resultQuery.sort((a, b) => a.id > b.id ? -1 : 1)
      } else {
        return this.resultQuery.sort((a, b) => a.id > b.id ? 1 : -1)
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)
      // Get Notices
      vm.$http.get('/caregiversV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.trueUser + '/pupilV2/' + vm.$store.state.pupilId + '/noticesV2/all')
        .then(resp => {
          vm.notices = resp.data
          vm.$store.commit('loading', false)
        })
    })
  },

  mounted: function () {
    this.$store.dispatch('logReadItems')
  }
}
</script>
